import {ComponentProps} from 'react';
import {twMerge} from 'tailwind-merge';

function Textarea({className, ...props}: ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={twMerge(
        'flex min-h-16 w-full resize-none rounded-xl border border-stroke bg-transparent px-3 py-2.5 text-base shadow-xs outline-none transition-[color,box-shadow,border] placeholder:text-muted-foreground focus:border-compliment disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className
      )}
      {...props}
    />
  );
}

export default Textarea;
